<template>
  <div id="headerblock" class="middle-aligned">
    <el-row :gutter="5">
      <el-col :span="18">
        <div class="grid-content">

        </div>
      </el-col>
      <el-col :span="6" >
        <div class="grid-content header-text middle-aligned" >
          <!-- TODO: add icon -->
          <span style="text-align:right">
            Испытуемый: {{ scenarioUser }}
          </span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import { mapGetters } from 'vuex'

  export default {
    name: 'appheader',
    data() {
      return {

      }
    },
    computed: {
      fullName: function() {
          //TODO: evaluate fullName
          return 'Тестовый Т. Т.';
      },
      ...mapGetters([
        'scenarioUser'
      ])
    }
  }
</script>

<style scoped>
  .middle-aligned {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .grid-content {
    min-height: 40px;
  }
  .header-text {
    color: #eef1f6;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/contest/header.vue